import React from 'react';

import type { IconProps } from '../../icon-types';
import { IconBase } from '../../IconBase';

export const MenuIcon = React.forwardRef<SVGSVGElement, IconProps>(function MenuIcon(props, ref) {
    return (
        <IconBase ref={ref} viewBox="0 0 24 24" {...props}>
            <path fill="currentColor" fillRule="evenodd" d="M3 8V6h18v2zm0 5h18v-2H3zm0 5h18v-2H3z" clipRule="evenodd"/>
        </IconBase>
    );
});
